<template>
    <div>
      <Head title="Admin" />
      <v-container class="grey lighten-5">
        <v-card>
          <v-card-title>
            Courses
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              @input="getDataFromApi()"
              single-line
              hide-details
            ></v-text-field>
            <v-spacer></v-spacer>
            
            <v-spacer></v-spacer>
            <v-btn
            class="mx-2"
            fab
            dark
            color="primary"
            @click="addNew"
          >
            <v-icon dark>
              mdi-plus
            </v-icon>
          </v-btn>
          </v-card-title>
          <v-data-table
            :headers="headers"
            :items="list"
            :options.sync="options"
            :items-per-page="itemsPerPage"
            :server-items-length="total"
            :loading="loading"
            class="elevation-1"
          >
          <template v-slot:item.actions="{ item }">
            <v-icon
              small
              class="mr-2"
              @click="edit(item.id)"
            >
              mdi-pencil
            </v-icon>
            
          </template>
        </v-data-table>
        </v-card> 

        <v-dialog v-model="dialogAdd"  fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
        >
          <v-card>
            <v-toolbar
          dark
          color="primary"
        >
          <v-btn
            icon
            dark
            @click="dialogAdd = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title v-if="dialogType == 'add'">Add New Course</v-toolbar-title>
          <v-toolbar-title v-if="dialogType == 'edit'">Edit {{newcourse.name}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
                v-if="dialogType=='add'"
              dark
              text
              @click="saveAddDialog"
            >
              Add
            </v-btn>
            <v-btn
                v-if="dialogType=='edit'"
              dark
              text
              @click="saveEditDialog"
            >
              Update
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container v-if="errors">
                <v-row>
                  <v-col cols="12" md="12">
                    <v-alert type="error">
                      <ul>
                        <li v-for="e in errors">
                          {{ e[0] }}
                        </li>
                      </ul>
                      
                    </v-alert>
                  </v-col>
                </v-row>
              </v-container>
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-select
                      v-model="newcourse.user_id"
                      label="User"
                      :items="users"
                      item-text="email"
                      item-value="id"
                    ></v-select>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-img :src="newcourse.photo_path" height="40" width="40">
                    </v-img>
                    <v-file-input
                        accept="image/*"
                      v-model="newcourse.photo"
                      label="Picture"
                      prepend-icon="mdi-camera"
                      clearable
                      
                    ></v-file-input>
                  </v-col>
                  
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.name"
                      label="Name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.alias"
                      label="Alias"
                      hint="No spaces or special characters, e.g. my-course"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.email"
                      label="Email"
                      prepend-icon="mdi-email"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.phone"
                      label="Phone"
                      prepend-icon="mdi-phone"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.url"
                      label="URL"
                      hint="https://www.example.com"
                      prepend-icon="mdi-web"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.facebook"
                      label="Facebook"
                      hint="https://www.facebook.com/myurl"
                      prepend-icon="mdi-facebook"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.instagram"
                      label="Instagram"
                      hint="https://www.instagram.com/myurl"
                      prepend-icon="mdi-instagram"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.twitter"
                      label="Twitter"
                      hint="https://www.twitter.com/myurl"
                      prepend-icon="mdi-twitter"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.linkedin"
                      label="LinkedIn"
                      hint="https://www.linkedin.com/myurl"
                      prepend-icon="mdi-linkedin"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <hr/>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-select
                      v-model="newcourse.region"
                      label="Region"
                      :items="regions"
                      clearable
                    ></v-select>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.address"
                      label="Address"
                      prepend-icon="mdi-map"
                    ></v-text-field>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                  >
                    <v-text-field
                      v-model="newcourse.postal_code"
                      label="Postal Code"
                      prepend-icon="mdi-map"
                    ></v-text-field>
                </v-col>
                </v-row>
                <hr/>
                <v-row>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                  >
                    <v-textarea
                      v-model="newcourse.description"
                      label="Description"
                    ></v-textarea>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                  >
                    <v-switch
                      v-model="newcourse.active"
                      label="Active"
                    ></v-switch>
                </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="4"
                  >
                  <v-switch
                      v-model="newcourse.is_returner_friendly"
                      label="Returner Friendly"
                    ></v-switch>
                </v-col>
                </v-row>
              </v-container>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="closeAddDialog"
              >
                Cancel
              </v-btn>
              <v-btn
                v-if="dialogType == 'add'"
                color="blue darken-1"
                text
                @click="saveAddDialog"
              >
                Add New
              </v-btn>
              <v-btn
                v-if="dialogType == 'edit'"
                color="blue darken-1"
                text
                @click="saveEditDialog"
              >
                Update
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" >
          <v-card>
            <v-card-title class="text-h5">Are you sure you want to delete this item?</v-card-title>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="dialogDelete = !dialogDelete">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-container>
    </div>
  </template>
  
  <script>
  import { Head } from '@inertiajs/inertia-vue'
  import Layout from '@/Shared/VuetifyAdminLayout'
  import axios from 'axios'
  
  const passwordLength = 12
  const passwordChars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'

  export default {
    props: {
      courses: Array,
      users:Array,
      regions:Array,
    },
    components: {
      Head,
    },
    layout: Layout,
    data() {
        return {
            list: [],
            keyword: "",
            location: "",
            category: "",
            errors:false,
            total: this.courses.length,
            itemsPerPage: 20,
            loading: false,
            loadingAdd: false,
            options: {},
            search: "",
            headers: [
              { text: 'ID', value:'id'},
              { text: 'Name', value:'name'},
              { text: 'Email', value:'email'},
              { text: 'Actions', value:'actions'}

            ],
            newcourse: {
              name:"",//
              email: "",//
              user_id: "",//
              alias: "",//
              phone: "",//
              url: "",//
              facebook: "",//
              twitter: "",//
              instagram: "",//
              linkedin: "",//
              contact_name: "",//
              description: "",//
              active: false,
              is_featured:false,
              is_returner_friendly:false,
              address: "",//
              city: "",//
              region: "",//
              country: "IE",//
              postal_code: "",//
              photo: [],
            },
            dialogType:'add',
            dialogAdd: false,
            dialogDelete: false
        }
    },
    watch: {
      options: {
        handler () {
          this.getDataFromApi()
        },
        deep: true,
      },
    },
    created() {
      this.list = JSON.parse(JSON.stringify(this.courses));
    },
    methods: {
      edit(id) {
        console.log('attempting to edit id ',id)
        axios.get("/admin/courses/get/"+id).then((response) => {
            console.log('edit got response',response.data)
            if (response && response.data)
            {
                this.newcourse = response.data
                this.dialogAdd = true;
                this.dialogType='edit';
            }
        });
      },
      addNew(){
        this.dialogType='add';
        Object.keys(this.newcourse).forEach(key => {
            if (key == 'photo')
                this.newcourse.key = []
            else
                this.newcourse[key] = "";
        });
        this.dialogAdd = true;
      },
      getDataFromApi () {
        this.loading = true
        console.log('getting request',this.options)
        var params = JSON.parse(JSON.stringify(this.options));
        params.filters = { search: this.search, role: this.role };

        axios.get("/admin/courses/list",{ params: params }).then((response) => {
          this.list = response.data.list
          this.total= response.data.total;
          this.loading = false;
        });
      },
      deleteItemConfirm () {
        this.closeDelete()
      },

      closeAddDialog () {
        this.dialogAdd = false
      },

      closeDelete () {
        this.dialogDelete = false
        
      },
      saveEditDialog () {
        this.loadingAdd=true;
        this.errors=false;
        const formData = new FormData()
        Object.keys(this.newcourse).forEach(key => formData.append(key, this.newcourse[key]));
        axios.post("/admin/courses/update",formData).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Edit failed');
          
            console.log('edit response',response)
            this.loadingAdd = false;
        }).catch(error => {
            console.log('error on edit',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        //this.dialogAdd = false
      },
      saveAddDialog () {
        this.loadingAdd=true;
        this.errors=false;
        console.log('adding course',this.newcourse)
        const formData = new FormData()
        Object.keys(this.newcourse).forEach(key => formData.append(key, this.newcourse[key]));
        axios.post("/admin/courses/add",formData).then((response) => {
          if (response.status == '200' && response.data == true)
          {
            this.dialogAdd = false;
            this.getDataFromApi();
          }
          else
            alert('Add failed');
          
            console.log('add response',response)
          this.loadingAdd = false;
        }).catch(error => {
            console.log('error on edit',error,error.response)
            this.errors = error.response && error.response.data && error.response.data.errors ? Object.values(error.response.data.errors) : []
            this.loadingAdd = false;
          });
        //this.dialogAdd = false
      },
      
    },
  }
  </script>
  